import toolPanelSteps from "./toolPanelSteps"
import codeEditorSteps from "./codeEditorSteps"
import previewWindowSteps from "./previewWindowSteps"
import componentSamplesSteps from "./componentSamplesSteps"
import savedThemesSteps from "./savedThemesSteps"

export default [
  ...toolPanelSteps,
  ...codeEditorSteps,
  ...previewWindowSteps,
  ...componentSamplesSteps,
  ...savedThemesSteps,
]
